import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import global_msg from './js/global.js'   //注意文件路径，实际路径以项目目录结构为准

Vue.prototype.$global_msg = global_msg;
Vue.config.productionTip = false

Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')

localStorage.setItem("url","http://pt.lingmeijie/api/")